import { createContext, useState } from "react";
import PropTypes from 'prop-types';

const AppContext = createContext();

const AppProvider = ({ children }) => {
    // registra i cambiamenti riguardo la lingua preferita
    const [language, setLanguage] = useState(() => {
        const storedLanguage = localStorage.getItem("language");
        return storedLanguage ? storedLanguage.replace(/"/g, "") : "it";
    });

    // funzione per cambiare lingua
    const changeLanguage = (selectedLanguage) => {
        localStorage.setItem('language', JSON.stringify(selectedLanguage)); // imposta la lingua preferita nel localstorage
        setLanguage(selectedLanguage); // seleziona la lingua nello useContext
    }

    return (
        <AppContext.Provider
            value={{
                language,
                setLanguage,
                changeLanguage
            }}>
            {children}
        </AppContext.Provider>
    );
};

AppProvider.propTypes = {
    children: PropTypes.node,
};

export { AppContext, AppProvider };